import { Flex, HStack, Icon, Text, Spacer, Box, Circle } from '@chakra-ui/react';

import * as fp from 'lodash/fp';

import { Coupon } from '~/icons';
import { IoChevronForward } from 'react-icons/io5';

type CouponBarProps = {
  availableCouponAmount: number;
  displayCouponAmount: number;
  onClick?: () => void;
};

export default function CouponBar({
  availableCouponAmount,
  displayCouponAmount,
  onClick,
}: CouponBarProps) {
  if (fp.gt(displayCouponAmount, 0)) {
    return (
      <Flex
        as="button"
        align="stretch"
        borderRadius="5px"
        boxShadow="0px 0px 8px #aaaaaa"
        onClick={onClick}
      >
        <HStack p={2}>
          <Icon as={Coupon} />
          <Text fontWeight="bold">優惠券</Text>
        </HStack>
        <Spacer />
        <Box bgColor="dark" p={2} borderRadius="0px 5px 5px 0px" position="relative">
          <Text color="white">查看可用優惠卷</Text>

          {fp.gt(availableCouponAmount, 0) && (
            <Circle
              w="1.25rem"
              h="1.25rem"
              bgColor="danger.600"
              position="absolute"
              right="-0.5rem"
              top="-0.5rem"
            >
              <Text fontSize="xs" color="white">
                {availableCouponAmount}
              </Text>
            </Circle>
          )}
        </Box>
      </Flex>
    );
  }

  return (
    <Flex align="center" p={2} as="button" onClick={onClick}>
      <HStack>
        <Icon as={Coupon} />
        <Text fontWeight="bold">優惠券</Text>
      </HStack>
      <Spacer />
      <Icon as={IoChevronForward} boxSize="1.25rem" />
    </Flex>
  );
}
